import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import WithdrawRequestSubWidget from '../../../widgets/progressReportWidget/withdraw/WithdrawRequestSubWidget'

import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import { getSubprojectWithdrawRequestForm } from '../../../redux/actions/withdrawRequest'

export default function WithdrawRequestSubproject(props) {
  const [isEditAll, setIsEditAll] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // let requestId = location.search.substring(1)
    let requestId = sessionStorage.getItem('param')?.substring(1)
    console.log('load ProgressReport project_id: ', projectId, 'request_id: ', requestId)

    handleGetSchema(projectId, requestId)
  }, [location.search])

  const handleGetSchema = async (projectId, requestId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubprojectWithdrawRequestForm(projectId, requestId)
      setSchemas(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProject>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {/* <BtnEditAll onClickEditAll={isEditAll} setOnClickEditAll={setIsEditAll} /> */}

        {schemas?.forms?.requestedDetails && (
          <AgreementAdditionalWidgets
            showCommandButton={true}
            formSchema={schemas.forms.requestedDetails}
          />
        )}

        {schemas?.forms?.budgetInfo && (
          <>
            <WithdrawRequestSubWidget
              showCommandButton={true}
              isEditAll={isEditAll}
              schema={schemas.forms}
              disabled={schemas.forms.requestNote.readOnly}
              //schema={withdrawRequest}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
